export default "__VITE_ASSET__CQLQ3IQY__"